import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/download.svg';

export const IconDownload: IconComponent = props => <Icon {...props} src={src} />;
